import { getStaffScopedApiPrefixOrCareAdvisor } from '@brands/Utils/staffScopedApiPrefix';

import { client } from '../client';
import {
  CreateOralHealthCoachingReportCarePlanParams,
  CreateOralHealthCoachingReportEducationParams,
  CreateOralHealthCoachingReportGoalParams,
  CreateOralHealthCoachingReportInternalNoteParams,
  ObjectType,
  UpdateOralHealthCoachingReportMediaParams,
  OralHealthCoachingReport,
} from './types/types';

export const updateOralHealthCoachingReportObject = async (
  oral_health_coaching_report_id: string,
  object_type: ObjectType,
  object_id: string,
  payload:
    | CreateOralHealthCoachingReportInternalNoteParams
    | CreateOralHealthCoachingReportEducationParams
    | CreateOralHealthCoachingReportGoalParams
    | CreateOralHealthCoachingReportCarePlanParams
    | UpdateOralHealthCoachingReportMediaParams,
  userRole?: string,
): Promise<OralHealthCoachingReport> => {
  const prefix = getStaffScopedApiPrefixOrCareAdvisor(userRole);
  const { data } = await client.put<OralHealthCoachingReport>(
    `${prefix}/oral_health_coaching_reports/${oral_health_coaching_report_id}/${object_type}/${object_id}`,
    payload,
  );

  return data;
};
